import { useTranslation } from "react-i18next";
import { FaceExpression } from "../../domain/types";

const FACE_EMOJI: Record<FaceExpression, string> = {
    [FaceExpression.NEUTRAL]: "😐",
    [FaceExpression.HAPPY]: "😀",
    [FaceExpression.SAD]: "😢",
    [FaceExpression.ANGRY]: "😠",
    [FaceExpression.SURPRISED]: "😲",
    [FaceExpression.FEARFUL]: "😨",
    [FaceExpression.GRATITUDE]: "🙏",
    [FaceExpression.PAIN]: "😣",
    [FaceExpression.TRUST]: "😊",
    [FaceExpression.LOVE]: "❤️",
    [FaceExpression.SHAME]: "😳",
    [FaceExpression.FEAR]: "😨",
    [FaceExpression.RAGE]: "😡",
    [FaceExpression.ANGER]: "😠",
    [FaceExpression.GUILT]: "😔",
    [FaceExpression.SADNESS]: "😢",
    [FaceExpression.ANXIETY]: "😰",
    [FaceExpression.JOY]: "😄",
};

// Curated list shown in the picker (avoids duplicate base/rich pairs).
const PICKER_EMOTIONS: FaceExpression[] = [
    FaceExpression.NEUTRAL,
    FaceExpression.JOY,
    FaceExpression.SADNESS,
    FaceExpression.RAGE,
    FaceExpression.FEAR,
    FaceExpression.ANXIETY,
    FaceExpression.LOVE,
    FaceExpression.GRATITUDE,
    FaceExpression.TRUST,
    FaceExpression.GUILT,
    FaceExpression.SHAME,
    FaceExpression.PAIN,
];

type Props = {
    value: FaceExpression;
    onChange: (face: FaceExpression) => void;
    label?: string;
};

export default function FacePicker({ value, onChange, label }: Props) {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col gap-1 text-xs">
            <span>{label ?? t("constellation.builder.emotion")}</span>
            <div className="grid grid-cols-5 gap-1">
                {PICKER_EMOTIONS.map((face) => (
                    <button
                        key={face}
                        type="button"
                        onClick={() => onChange(face)}
                        title={t(`constellation.face.${face}`)}
                        aria-label={t(`constellation.face.${face}`)}
                        aria-pressed={value === face}
                        className={`flex flex-col items-center gap-0.5 rounded-md border px-1 py-1 transition-all ${
                            value === face
                                ? "border-brand-500 bg-brand-50 ring-2 ring-brand-200"
                                : "border-gray-100 hover:border-brand-200"
                        }`}
                    >
                        <span className="text-base" aria-hidden>
                            {FACE_EMOJI[face]}
                        </span>
                        <span className="w-full truncate text-center text-[9px] leading-tight text-gray-600">
                            {t(`constellation.face.${face}`)}
                        </span>
                    </button>
                ))}
            </div>
        </div>
    );
}
